(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
